/** Small formatting + query-string helpers shared across panels. */

/** Build a `?a=1&b=2` string, dropping empty/undefined values. */
export function qs(params: Record<string, string | number | undefined | null>): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== null && v !== '') p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : '';
}

/** ISO → local time. `timeOnly` gives HH:MM:SS (for dense log tables). */
export function fmtTime(iso: string | null | undefined, timeOnly = false): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return String(iso);
  return timeOnly ? d.toLocaleTimeString() : d.toLocaleString();
}

/** Human "time left until" an ISO instant, e.g. "23h 40m" / "expired". */
export function until(iso: string | null | undefined): string {
  if (!iso) return '—';
  const ms = new Date(iso).getTime() - Date.now();
  if (Number.isNaN(ms)) return '—';
  if (ms <= 0) return 'expired';
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
}
